import React from 'react';
import dayjs from 'dayjs';
import { BrandedAlertModal } from 'components/Modal';

interface PostShiftModalProps {
  isOpen: boolean;
  selectedDate: Date | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const CalendarHeaderIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <rect x="3.5" y="5" width="17" height="15" rx="2.5" stroke="currentColor" strokeWidth="1.6" />
    <path d="M3.5 9.5h17" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 3.5v3M16 3.5v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const CalendarIllustration: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <rect x="3" y="5" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M8.5 15.5l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PostShiftModal: React.FC<PostShiftModalProps> = ({
  isOpen,
  selectedDate,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen || !selectedDate) return null;

  const formattedDate = dayjs(selectedDate).format('dddd, MMMM D, YYYY');

  return (
    <BrandedAlertModal
      isOpen={isOpen}
      onClose={onCancel}
      headerLabel="New Shift"
      headerIcon={<CalendarHeaderIcon />}
      illustration={<CalendarIllustration />}
      illustrationVariant="info"
      title="Post a Temping Shift"
      ariaLabel="Confirm posting a temping shift"
      actions={[
        { label: 'No', onClick: onCancel, variant: 'secondary' },
        { label: 'Yes', onClick: onConfirm, variant: 'primary' },
      ]}
    >
      Post a Temping Shift for <strong>{formattedDate}</strong>?
    </BrandedAlertModal>
  );
};

export default PostShiftModal;
